import axios, { Axios } from 'axios';

export const FILE_SERVER_BASE_URL = 'http://172.16.29.50:28385';
export const FILE_SERVER_IMAGE_BASE_URL = 'http://172.16.29.50:7777';

const myAxios = axios.create({
  baseURL: FILE_SERVER_BASE_URL,
  timeout: 10 * 60 * 1000,
});
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
myAxios.defaults.headers.post['Content-Type'] = 'application/json;';
myAxios.defaults.headers.put['Content-Type'] = 'application/json';
// 添加请求拦截器
myAxios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
myAxios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  },
);

// 动作列表 :@{@"actionId":SAFE_STRING(actionId)}
export async function getActionList(params) {
  return myAxios.post('/modelTrain/getActionList', params);
}
// 动作列表 :@{@"actionId":SAFE_STRING(actionId)}
export async function getClassify(params) {
  return myAxios.post('/modelTrain/getClassifyByActionId', params);
}

// @{@"actionId":SAFE_STRING(actionId), @"problem":serchStr}
export async function getActionPicList(params) {
  return myAxios.post('/modelTrain/getActionPicList', params);
}

//图片id
//视角，默认正面
//下方选了的节点
//1表示选了，0表示弃单
// @{@"id":@(imgId), @"visual":SAFE_STRING(visual), @"node":SAFE_STRING(node), @"result": @(result)}
export async function updateActionPic(params) {
  return myAxios.post('/modelTrain/updateActionPic', params);
}

// @{@"actionId":SAFE_STRING(actionId), @"actionName":SAFE_STRING(actionName), @"imageUrl":SAFE_STRING(imageUrl), @"node":SAFE_STRING(node)}
export async function addClassifyImage(params) {
  return myAxios.post('/modelTrain/addClassifyImage', params);
}

// @{@"id":@(imgId)}
export async function removeTrainImageClassify(params) {
  return myAxios.post('/modelTrain/removeTrainImageClassify', params);
}

//图片id
//视角，默认正面
//下方选了的节点
//1表示选了，0表示弃单
// @{@"id":@(imgId), @"visual":SAFE_STRING(visual), @"node":SAFE_STRING(node), @"result": @(result)}
export async function batchUpdateActionPic(params) {
  return myAxios.post('/modelTrain/batchUpdateActionPic', params);
}

/**
 * 添加错误分类
 * @param {} params {
  "action_id":888888,
  "node":"node1",
  "node_name":"ceshi",
  "url":"urlurl"
}
 * @returns 
 */
export async function addClassify(params) {
  return myAxios.post('/modelTrain/addClassify', params);
}
